import { TriggerObject, WorkflowRun } from 'dashboard/models/workflow-run';
import { WorkflowRunSimulated } from 'dashboard/models/workflow-run-simulated';
import { WorkflowRunStep, WorkflowRunStepKnownObjects } from 'dashboard/models/workflow-step';
import Action from 'lib/interfaces/Action';

interface WorkflowRunPayload {
  workflowRun: WorkflowRun | WorkflowRunSimulated;
}

interface WorkflowRunTriggerObjectPayload {
  triggerObject: TriggerObject;
}

interface WorkflowRunStepsPayload {
  steps: WorkflowRunStep[];
}

interface WorkflowRunLoopChildrenStepsPayload {
  loopChildrenSteps: Record<string, Record<number, WorkflowRunStep[]>>;
}

interface WorkflowRunKnownObjectsPayload {
  knownObjects: WorkflowRunStepKnownObjects[];
}

export type WorkflowRunActions =
  | Action<WorkflowRunActionType.SetWorkflowRun, WorkflowRunPayload>
  | Action<WorkflowRunActionType.ClearWorkflowRun>
  | Action<WorkflowRunActionType.SetWorkflowRunSteps, WorkflowRunStepsPayload>
  | Action<
      WorkflowRunActionType.SetWorkflowRunLoopChildrenSteps,
      WorkflowRunLoopChildrenStepsPayload
    >
  | Action<WorkflowRunActionType.SetWorkflowRunTriggerObject, WorkflowRunTriggerObjectPayload>
  | Action<WorkflowRunActionType.SetWorkflowRunKnownObjects, WorkflowRunKnownObjectsPayload>;

export enum WorkflowRunActionType {
  SetWorkflowRun = 'workflow-run/SET_WORKFLOW_RUN',
  ClearWorkflowRun = 'workflow-run/CLEAR_WORKFLOW_RUN',
  SetWorkflowRunSteps = 'workflow-run/SET_WORKFLOW_RUN_STEPS',
  SetWorkflowRunLoopChildrenSteps = 'workflow-run/SET_WORKFLOW_RUN_LOOP_CHILDREN_STEPS',
  SetWorkflowRunTriggerObject = 'workflow-run/SET_WORKFLOW_RUN_TRIGGER_OBJECT',
  SetWorkflowRunKnownObjects = 'workflow-run/SET_WORKFLOW_RUN_KNOWN_OBJECTS',
}

export function setWorkflowRun(
  workflowRun: WorkflowRun | WorkflowRunSimulated,
): Action<WorkflowRunActionType.SetWorkflowRun, WorkflowRunPayload> {
  return {
    payload: {
      workflowRun,
    },
    type: WorkflowRunActionType.SetWorkflowRun,
  };
}

export function setWorkflowRunSteps(
  steps: WorkflowRunStep[],
): Action<WorkflowRunActionType.SetWorkflowRunSteps, WorkflowRunStepsPayload> {
  return {
    payload: {
      steps,
    },
    type: WorkflowRunActionType.SetWorkflowRunSteps,
  };
}

export function setWorkflowRunLoopChildrenSteps(
  loopChildrenSteps: Record<string, Record<number, WorkflowRunStep[]>>,
): Action<
  WorkflowRunActionType.SetWorkflowRunLoopChildrenSteps,
  WorkflowRunLoopChildrenStepsPayload
> {
  return {
    payload: {
      loopChildrenSteps,
    },
    type: WorkflowRunActionType.SetWorkflowRunLoopChildrenSteps,
  };
}

export function setWorkflowRunTriggerObject(
  triggerObject: TriggerObject,
): Action<WorkflowRunActionType.SetWorkflowRunTriggerObject, WorkflowRunTriggerObjectPayload> {
  return {
    payload: {
      triggerObject,
    },
    type: WorkflowRunActionType.SetWorkflowRunTriggerObject,
  };
}

export function setWorkflowRunKnownObjects(
  knownObjects: WorkflowRunStepKnownObjects[],
): Action<WorkflowRunActionType.SetWorkflowRunKnownObjects, WorkflowRunKnownObjectsPayload> {
  return {
    payload: {
      knownObjects,
    },
    type: WorkflowRunActionType.SetWorkflowRunKnownObjects,
  };
}

export function clearWorkflowRun(): Action<WorkflowRunActionType.ClearWorkflowRun> {
  return { type: WorkflowRunActionType.ClearWorkflowRun };
}
